module.exports = __webpack_public_path__ + "img/services-flow-vertical.d8d8b3a6.png";